
import React from "react";
import styles from "../assets/style.module.css";
import * as ReactRouterDom from "react-router-dom";
import { ApiResponseData, BaseService, ITournamentEditionPrizePool, IProfileWebsite, ITournamentEditionWebsite, OmneHostService, SanitizedResponse } from "../../../../services";
import { alertDialog, Classname, FileHelper, fileInputBuildFileInputPreview, FileInputPreviewType, Paginator, Scheme, StringHelper, useSearchParams } from "@rivtn/noseur";
import { Utils } from "../../../../utils";
import { i18nManager } from "../../../../i18n";

const TROPHY_WINNERS: any[] = [
    { id: 1, name: "FC Vanguard", img: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=300&q=80", country: "Nigeria", flag: "🇳🇬", place: 1, placeLabel: "1st Place 🥇", cashPayout: "$50,000", physicalPrize: "Gold Trophy + Medals", game: "Football / 11v11", season: "S4 2025" },
    { id: 2, name: "Storm Force", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&q=80", country: "Ghana", flag: "🇬🇭", place: 2, placeLabel: "2nd Place 🥈", cashPayout: "$25,000", physicalPrize: "Silver Trophy + Medals", game: "Football / 11v11", season: "S4 2025" },
    { id: 3, name: "Iron Legion", img: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&q=80", country: "US", flag: "🇺🇸", place: 3, placeLabel: "3rd Place 🥉", cashPayout: "$12,500", physicalPrize: "Bronze Trophy", game: "Football / 11v11", season: "S4 2025" },
    { id: 4, name: "Marco Vidal", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&q=80", country: "Nigeria", flag: "🇳🇬", place: 4, placeLabel: "MVP Award ⭐", cashPayout: "$5,000", physicalPrize: "Golden Boot Trophy", game: "Football / 11v11", season: "S4 2025" },
    { id: 5, name: "Nova Esports", img: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=300&q=80", country: "UK", flag: "🇬🇧", place: 1, placeLabel: "1st Place 🥇", cashPayout: "$35,000", physicalPrize: "Gold Trophy + Medals", game: "Football / 11v11", season: "S3 2024" },
    { id: 6, name: "Alpha United", img: "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=300&q=80", country: "India", flag: "🇮🇳", place: 2, placeLabel: "2nd Place 🥈", cashPayout: "$17,500", physicalPrize: "Silver Trophy + Medals", game: "Football / 11v11", season: "S3 2024" },
    { id: 7, name: "Phantom GG", img: "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=300&q=80", country: "Ghana", flag: "🇬🇭", place: 3, placeLabel: "3rd Place 🥉", cashPayout: "$8,500", physicalPrize: "Bronze Trophy", game: "Football / 11v11", season: "S3 2024" },
    { id: 8, name: "Lucas Ferreira", img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=300&q=80", country: "UK", flag: "🇬🇧", place: 4, placeLabel: "MVP Award ⭐", cashPayout: "$3,500", physicalPrize: "Golden Boot Trophy", game: "Football / 11v11", season: "S3 2024" },
];

export interface TrophiesProps {
    website: ITournamentEditionWebsite;
}

function Trophies(props: TrophiesProps) {

    const { website } = props;
    const labels = i18nManager.Labels.gallery;
    const omnehostService = OmneHostService.getInstance();
    const { page, setPage, tipe, setTipe } = useSearchParams({ defaultInit: window.location.search, params: { page: 1, tipe: "" } });
    const [tournamentEditionPrizePools, setTournamentEditionPrizePools] = React.useState<ApiResponseData<ITournamentEditionPrizePool>>();

    const [seasonFilter, setSeasonFilter] = React.useState<string>("All");

    const filtered = seasonFilter === "All" ? TROPHY_WINNERS : TROPHY_WINNERS.filter(w => w.season === seasonFilter);

    const cardClass = (place: number) =>
        place === 1
            ? styles["tp1"]
            : place === 2
                ? styles["tp2"]
                : place === 3
                    ? styles["tp3"]
                    : styles["tpother"];

    React.useEffect(fetchInformation, [omnehostService, tipe, page]);

    return (<div className={styles["section"]}>
        <div className={styles["sec-line"]} />
        <h1 className={styles["sec-title"]}>Trophy <em>Winners</em></h1>
        <p className={styles["sec-sub"]}>All-time Nexus Cup champions, runners-up and award recipients</p>

        {(!website.tournament_edition.meta.prize_pool_distributed) && (<div style={{ marginBottom: 40, border: "1px solid var(--gold)", borderRadius: 7, padding: 20 }}>
            Winner of the prizes and trophy wil be update once the host distribute the prize
        </div>)}

        <div className={styles["tabs"]}>
            {[["", "All"], ["TW", "Top Winner"], ["T", "Trophies"]].map(([k, v]) => (
                <button
                    key={k}
                    className={`${styles["tab-btn"]} ${tipe === k ? styles["active"] : ""}`}
                    onClick={() => { setTipe(k); }}
                >
                    {v}
                </button>
            ))}
        </div>

        {(!!tournamentEditionPrizePools?.content)
            ? ((tournamentEditionPrizePools.content && tournamentEditionPrizePools.content?.length > 0)
                ? (<div className={styles["trophy-grid"]}>
                    {tournamentEditionPrizePools.content!.map((pp) => {

                        const currencyPrizes = Object.entries(pp.currency_prizes ?? {});
                        const winnerCountry = pp.winner?.resource?.country_code ?? "NGA";
                        const winnerName = pp.winner?.resource?.username ?? pp.winner?.resource?.name ?? pp.title;
                        const winnerPicture = pp.winner?.resource?.profile_picture_url ?? pp.winner?.resource?.logo_url;

                        return (<div key={pp.external_id} className={`${styles["tw-card"]} ${cardClass(pp.position)}`}>
                            {(!!winnerPicture) && (<img className={styles["tw-img"]} src={winnerPicture} alt={winnerName} loading="lazy" />)}
                            <div className={styles["tw-body"]}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                    <img src={pp.logo_url} alt={pp.title} loading="lazy" style={{ width: 25, height: 25, borderRadius: "100%", marginRight: 10, border: "1px solid var(--gold)" }} />
                                    <div className={styles["tw-place"]} style={{ color: pp.position === 1 ? "var(--gold)" : pp.position === 2 ? "#c8c8d8" : pp.position === 3 ? "#e8a055" : "#7B96FF" }}>
                                        {pp.title}
                                    </div>
                                </div>
                                {(!!pp.winner) && (<ReactRouterDom.NavLink target="_blank" to={`${window.location.origin}/${!!pp.winner?.resource?.username ? "me" : "te"}/${pp.winner?.resource?.external_id}`} className={styles["unlinked"]}>
                                    <hr style={{ marginTop: 5 }} />
                                    <p style={{ color: "var(--muted)", margin: "5px 0px", opacity: 0.5 }}>Winner</p>
                                    <div className={styles["tw-name"]}>{winnerName}</div>
                                    <div className={styles["tw-country"]}>{i18nManager.queryCountryCurrency(winnerCountry, "country_code", "country_name")}</div>
                                    <hr style={{ marginBottom: 10 }} />
                                </ReactRouterDom.NavLink>)}
                                {(!!currencyPrizes.length) && (<div className={styles["tw-cash-lbl"]} style={{ marginBottom: 5 }}>Cash Payout</div>)}
                                {currencyPrizes.map(([currency, amount]) => (<div className={styles["tw-cash"]}>{i18nManager.queryCountryCurrency(currency, "currency_code", "currency_sign")} {StringHelper.toPresentableMoneyValue(amount)}</div>))}
                                {(pp.physical_prize?.name || pp.physical_prize?.detail_link || pp.physical_prize?.image_url) && (<>
                                    <div className={styles["tw-cash-lbl"]} style={{ margin: "10px 0px" }}>Physical Prize</div>
                                    <div className={styles["tw-physical"]}>🏆 {pp.physical_prize.name ?? pp.physical_prize.detail_link ?? "Physical Prize"}</div>
                                    {(pp.physical_prize.image_url) && (<img className={styles["tw-physical"]} src={pp.physical_prize.image_url} alt={pp.physical_prize.name} loading="lazy" style={{ height: 150, width: "100%" }} />)}
                                </>)}
                            </div>
                        </div>);
                    })}
                </div>)
                : (Utils.emptyState()))
            : (Utils.loadingState())}

        <Paginator scheme={Scheme.LIGHT} style={{ marginTop: 50 }} rowsPerPage={tournamentEditionPrizePools?.size} totalRecords={tournamentEditionPrizePools?.total_elements} initialPage={parseInt("" + page)} onPageChange={(e) => {
            setPage(e.currentPage)
        }} template={{
            activePageLabel: () => "",
            nextPageElement: (option) => (<button className={Classname.build(`${styles["pg-btn"]}`, option.className, "fa fa-angle-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            previousPageElement: (option) => (<button className={Classname.build(`${styles["pg-btn"]}`, option.className, "fa fa-angle-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            lastPageElement: (option) => (<button className={Classname.build(`${styles["pg-btn"]}`, option.className, "fa fa-angle-double-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            firstPageElement: (option) => (<button className={Classname.build(`${styles["pg-btn"]}`, option.className, "fa fa-angle-double-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            pageElement: (option) => (<button className={Classname.build(`${styles["pg-btn"]}`, option.className, (option.active ? styles["active"] : null))} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick}>{option.label}</button>),
        }} />
    </div>);

    function fetchInformation() {
        setTournamentEditionPrizePools({});
        omnehostService.queryTournamentEditionPrizePools(props.website.tournament_edition.external_id, {
            page,
            sort: "updated_at,DESC",
            type: (tipe === "" ? "" : (tipe === "TW" ? "TOP_WINNER" : "TROPHY")),
        }).then(({ apiResponse }: SanitizedResponse<ITournamentEditionPrizePool>) => {
            setTournamentEditionPrizePools(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default Trophies;